import { render, staticRenderFns } from "./CardSkeleton.vue?vue&type=template&id=b7fb2e24&scoped=true"
var script = {}
import style0 from "./CardSkeleton.vue?vue&type=style&index=0&id=b7fb2e24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7fb2e24",
  null
  
)

export default component.exports